/**
 * The HTML `marked` makes from report Markdown, as a tree the PDF renderers can walk.
 *
 * Markdown passes raw HTML through, and the Markdown here is document content: an
 * element created in the live page loads `<img src=x onerror=…>` even while detached,
 * so the export used to run it with only the deployed CSP in the way (MYAC-1561). A
 * `DOMParser` document has no browsing context: nothing in it loads or runs, and the
 * renderers only read its nodes.
 */
export function parseInertHtml(html: string): HTMLElement {
  return new DOMParser().parseFromString(html, 'text/html').body
}
